export default {
  FETCH_CONSTRUCTIONS_SUCCESS: 'FETCH_CONSTRUCTIONS_SUCCESS',
  FETCH_CONSTRUCTIONS_START: 'FETCH_CONSTRUCTIONS_START',
  CONSTRUCTION_TYPE_SELECTED: 'CONSTRUCTION_TYPE_SELECTED',
  UPDATE_DOOR_PREVIEW: 'UPDATE_DOOR_PREVIEW',

  FETCH_CONSTRUCTION_PARTS_SUCCESS: 'FETCH_CONSTRUCTION_PARTS_SUCCESS',
  FETCH_CONSTRUCTION_PARTS_START: 'FETCH_CONSTRUCTION_PARTS_START',

  GROUP_SELECTED: 'GROUP_SELECTED',
  CUSTOM_SIZE_SELECTED: 'CUSTOM_SIZE_SELECTED',
  SIZE_SELECTED: 'SIZE_SELECTED',
  SET_DEFAULT_ORDER_STATE: 'SET_DEFAULT_ORDER_STATE',
  OPEN_TYPE_SELECTED: 'OPEN_TYPE_SELECTED',

  CONSTRUCTION_PART_SELECTED: 'CONSTRUCTION_PART_SELECTED',
  CONSTRUCTION_ITEM_GROUPED_SELECTED: 'CONSTRUCTION_ITEM_GROUPED_SELECTED',

  UPDATE_ORDER_PARAMS: 'UPDATE_ORDER_PARAMS',
  SEND_ORDER_START: 'SEND_ORDER_START',
  SEND_ORDER_SUCCESS: 'SEND_ORDER_SUCCESS',
  STEP_VALID: 'STEP_VALID',
  STEP_INVALID: 'STEP_INVALID',

  SHOW_HINT: 'SHOW_HINT',
  HIDE_HINT: 'HIDE_HINT',

  SET_FORCE_POPUP_FOR: 'SET_FORCE_POPUP_FOR',

  SHOW_POPUP: 'SHOW_POPUP',
  HIDE_POPUP: 'HIDE_POPUP',

  REMOVE_FROM_ACTIONS_CHAIN: 'REMOVE_FROM_ACTIONS_CHAIN',
  ADD_TO_ACTIONS_CHAIN: 'ADD_TO_ACTIONS_CHAIN',

  OPEN_ORDER_CALL_WINDOW: 'OPEN_ORDER_CALL_WINDOW',
  CLOSE_ORDER_CALL_WINDOW: 'CLOSE_ORDER_CALL_WINDOW',
  SEND_ORDER_CALL_START: 'SEND_ORDER_CALL_START',
  SEND_ORDER_CALL: 'SEND_ORDER_CALL',
  SEND_ORDER_CALL_SUCCESS: 'SEND_ORDER_CALL_SUCCESS',
  SEND_ORDER_CALL_FAILED: 'SEND_ORDER_CALL_FAILED',
  UPDATE_ORDER_CALL_FORM_DATA: 'UPDATE_ORDER_CALL_FORM_DATA',
  ORDER_CALL_ADD_ERROR: 'ORDER_CALL_ADD_ERROR',
  ORDER_CALL_REMOVE_ERROR: 'ORDER_CALL_REMOVE_ERROR',
  ORDER_CALL_CLEAR_ERRORS: 'ORDER_CALL_CLEAR_ERRORS',
}


// WEBPACK FOOTER //
// ./app/javascript/app/constants/actions.jsx